enum FEATURE_FLAGS {
  ADOPT_APP = 'adopt_app',
  CASH_DRAWER = 'cash_drawer',
  CLINIC_OUT_PAYMENTS = 'enable_clinic_out_payments',
  COMMUNITY_SUPPORT = 'community_support',
  FIELD_SERVICES = 'field_services',
  FORMS_AND_APPLICATIONS = 'unlimited_forms',
  HILLS_REPORT = 'hills_report',
  KENNEL_MANAGER = 'use_kennel_manager',
  LOST_AND_FOUND = 'lost_found',
  PETCADEMY = 'petcademy',
  REHOME = 'rehome',
  SERVICE_OUT_PAYMENTS = 'enable_service_out_payments',
  TNVR = 'tnvr',
  TRANSPORTS = 'transports',
  VCA_REPORT = 'vca_report',
  VISUAL_KENNEL = 'visual_kennel',
}

export { FEATURE_FLAGS };
